import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { endpoint } from "../../api/endpoint";
import { apiHandler } from "../../api";
import { debounce } from "lodash";
import { useNavigate } from "react-router-dom";

const useStoreQC = () => {
  const [data, setData] = useState([]);
  const { client: rootClient, environment: rootEnvironment } = useSelector(
    (state) => state.configurationSlice
  );
  const { authData, userData } = useSelector((state) => state.loginSlice);
  const [loader, setLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(null);
  const [jsonBody, setJsonBody] = useState(null);
  const [openJson, setOpenJson] = useState(false);
  const [remarkBody, setremarkBody] = useState(null);
  const [openRemark, setOpenRemark] = useState(false);
  const [variantId, setVariantId] = useState("");
  const [productId, setProductId] = useState("");

  const [category, setCategory] = useState("");
  const [title, setTitle] = useState("");
  const [issueType, setIssueType] = useState("");
  const [buyerApp, setBuyerApp] = useState("");
  const [issueTypes, setIssueTypes] = useState("");
  const [buyerApps, setBuyerApps] = useState([]);
  const [createdAt, setCreatedAt] = useState("");
   const [activeTab, setActiveTab] = useState("storeqc");
  const [key, setKey] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const debouncedPageChange = useCallback(
    debounce((value) => {
      const page = parseInt(value, 10);
      setCurrentPage(page);
    }, 500),
    []
  );

  const handleInputPageChange = (e) => {
    debouncedPageChange(e.target.value);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handlePageSize = (limit) => {
    setPageSize(limit.target.value);

    setCurrentPage(currentPage + 1);
  };

  const fetchLogs = async () => {
    try {
      setLoader(true);
      if (rootClient && rootEnvironment) {
        let url = `${endpoint.GET_QC}/${rootClient}/${rootEnvironment}?page=${
          currentPage || 1
        }&limit=${pageSize || 5}`;
        

       

        if (category) {
          url += `&category=${category.replace(/"/g, "")}`;
        }
         if (title) {
          url += `&title=${title.replace(/"/g, "")}`;
        }
         if (productId) {
          url += `&productId=${productId.replace(/"/g, "")}`;
        }
        if (variantId) {
          url += `&variantId=${variantId.replace(/"/g, "")}`;
        }
       

        if (issueType) {
          url += `&issueType=${issueType}`;
        }

        if (createdAt) {
          url += `&createdAt=${createdAt}`;
        }

        // if (buyerApp) {
        //   url += `&buyerApp=${buyerApp}`;
        // }

        const response = await apiHandler({
          url: url,
          method: "GET",
          authToken: authData,
          navigate,
          dispatch,
        });

        if (response.data.success) {
          setData(response.data.data.qcData);
          setTotalCount(response.data.data.total);
          setIssueTypes(response.data.data.filterOptions.issueType);
          setBuyerApps(response.data.data.filterOptions.buyerApp);
        } else {
          setData([]);
          //console.error("Failed to fetch Orders:", response.data.message);
        }
      }
    } catch (error) {
      //console.error("Error fetching Orders:", error);
      setData([]);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, [
    pageSize,
    rootClient,
    rootEnvironment,
    issueType,
    // buyerApp,
    variantId,
    productId,
    category,
    title,
    createdAt,
    currentPage,
  ]);

  return {
    data,
    currentPage,
    loader,
    totalCount,
    pageSize,
    handleInputPageChange,
    handlePageChange,
    handlePageSize,
    jsonBody,
    setJsonBody,
    setOpenJson,
    openJson,
    remarkBody,
    setremarkBody,
    openRemark,
    setOpenRemark,
    variantId,
    setVariantId,
    productId,
    setProductId,
    category,
    setCategory,
    title,
    setTitle,
    issueType,
    setIssueType,
    // buyerApp,
    // setBuyerApp,
    issueTypes,
    setIssueTypes,
    buyerApps,
    setBuyerApps,
    createdAt,
    setCreatedAt,
    activeTab,
    setActiveTab,
    key,
    setKey
  };
};

export default useStoreQC;
